var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("app-side-menu", [
    _c(
      "aside",
      { staticClass: "menu", attrs: { slot: "side-menu" }, slot: "side-menu" },
      [
        _c("p", { staticClass: "menu-label" }, [
          _c("span", { staticClass: "title is-6" }, [_vm._v(" Filters ")]),
        ]),
        _c("ul", { staticClass: "menu-list" }, [
          _c("li", [
            _c("div", { staticClass: "field" }, [
              _c("div", { staticClass: "control" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.value.claimNo,
                      expression: "value.claimNo",
                    },
                  ],
                  staticClass: "input is-uppercase",
                  attrs: { type: "text", placeholder: "Claim No." },
                  domProps: { value: _vm.value.claimNo },
                  on: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.onFilterClick()
                    },
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.value, "claimNo", $event.target.value)
                    },
                  },
                }),
              ]),
            ]),
            _c("div", { staticClass: "field" }, [
              _c("div", { staticClass: "control" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.value.displayName,
                      expression: "value.displayName",
                    },
                  ],
                  staticClass: "input is-uppercase",
                  attrs: { type: "text", placeholder: "Display Name" },
                  domProps: { value: _vm.value.displayName },
                  on: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.onFilterClick()
                    },
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.value, "displayName", $event.target.value)
                    },
                  },
                }),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "field" },
              [
                _c("v-date-picker", {
                  attrs: {
                    "is-dark": _vm.$theme.isDark,
                    masks: _vm.formats,
                    attributes: _vm.attrs,
                    locale: _vm.$userInfo.locale,
                    "model-config": _vm.modelConfig,
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ inputValue, inputEvents }) {
                        return [
                          _c("div", { staticClass: "field" }, [
                            _c(
                              "div",
                              { staticClass: "control has-icons-left" },
                              [
                                _c(
                                  "input",
                                  _vm._g(
                                    {
                                      staticClass: "input",
                                      attrs: {
                                        type: "text",
                                        placeholder: "From Date",
                                      },
                                      domProps: { value: inputValue },
                                    },
                                    inputEvents
                                  )
                                ),
                                _c(
                                  "span",
                                  { staticClass: "icon is-small is-left" },
                                  [
                                    _c("i", {
                                      staticClass: "mdi mdi-calendar mdi-18px",
                                    }),
                                  ]
                                ),
                              ]
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                  model: {
                    value: _vm.selectedCreationDate,
                    callback: function ($$v) {
                      _vm.selectedCreationDate = $$v
                    },
                    expression: "selectedCreationDate",
                  },
                }),
              ],
              1
            ),
            _c("div", { staticClass: "field" }, [
              _c("div", { staticClass: "control" }, [
                _c("label", { staticClass: "label" }, [_vm._v("Task Status")]),
                _c("div", { staticClass: "select" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.value.taskStatus,
                          expression: "value.taskStatus",
                        },
                      ],
                      on: {
                        change: function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.value,
                            "taskStatus",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        },
                      },
                    },
                    [
                      _c(
                        "option",
                        { attrs: { selected: "selected", value: "open" } },
                        [_vm._v("Open")]
                      ),
                      _c("option", { attrs: { value: "closed" } }, [
                        _vm._v("Closed"),
                      ]),
                      _c("option", { attrs: { value: "all" } }, [
                        _vm._v("All"),
                      ]),
                    ]
                  ),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "field" }, [
              _c("div", { staticClass: "control" }, [
                _c("label", { staticClass: "label" }, [_vm._v("Task Type")]),
                _c("div", { staticClass: "select" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.value.taskType,
                          expression: "value.taskType",
                        },
                      ],
                      on: {
                        change: function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.value,
                            "taskType",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        },
                      },
                    },
                    [
                      _c(
                        "option",
                        { attrs: { selected: "selected", value: "" } },
                        [_vm._v("All")]
                      ),
                      _c("option", { attrs: { value: "AudaNet" } }, [
                        _vm._v("AudaNet"),
                      ]),
                      _c("option", { attrs: { value: "AudaBridge" } }, [
                        _vm._v("AudaBridge"),
                      ]),
                    ]
                  ),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "field" }, [
              _c("div", { staticClass: "control" }, [
                _c("label", { staticClass: "label" }, [_vm._v("Job Status")]),
                _c("div", { staticClass: "select" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.value.businessStatusText,
                          expression: "value.businessStatusText",
                        },
                      ],
                      on: {
                        change: function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.value,
                            "businessStatusText",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        },
                      },
                    },
                    [
                      _c(
                        "option",
                        { attrs: { selected: "selected", value: "" } },
                        [_vm._v("All")]
                      ),
                      _c("option", { attrs: { value: "Authorised" } }, [
                        _vm._v("Authorised"),
                      ]),
                      _c("option", { attrs: { value: "Cancelled" } }, [
                        _vm._v("Cancelled"),
                      ]),
                      _c("option", { attrs: { value: "Closed" } }, [
                        _vm._v("Closed"),
                      ]),
                      _c(
                        "option",
                        { attrs: { value: "Closed - Total Loss" } },
                        [_vm._v("Closed - Total Loss")]
                      ),
                      _c("option", { attrs: { value: "Created" } }, [
                        _vm._v("Created"),
                      ]),
                      _c(
                        "option",
                        {
                          attrs: { value: "Modified Supplementary Authorised" },
                        },
                        [_vm._v("Modified Supplementary Authorised")]
                      ),
                      _c("option", { attrs: { value: "Pending Auth" } }, [
                        _vm._v("Pending Auth"),
                      ]),
                      _c(
                        "option",
                        { attrs: { value: "Potential Total Loss" } },
                        [_vm._v("Potential Total Loss")]
                      ),
                      _c(
                        "option",
                        { attrs: { value: "Reopened - Supp Added" } },
                        [_vm._v("Reopened - Supp Added")]
                      ),
                      _c("option", { attrs: { value: "RFQ Received" } }, [
                        _vm._v("RFQ Received"),
                      ]),
                      _c(
                        "option",
                        { attrs: { value: "Supp Auth. Rejected" } },
                        [_vm._v("Supp Auth. Rejected")]
                      ),
                      _c("option", { attrs: { value: "Supp Authorised" } }, [
                        _vm._v("Supp Authorised"),
                      ]),
                      _c("option", { attrs: { value: "Supp Pending Auth" } }, [
                        _vm._v("Supp Pending Auth"),
                      ]),
                      _c(
                        "option",
                        { attrs: { value: "Supplementary Added" } },
                        [_vm._v("Supplementary Added")]
                      ),
                    ]
                  ),
                ]),
              ]),
            ]),
          ]),
        ]),
        _c("hr"),
        _c("div", { staticClass: "field is-grouped is-pulled-right" }, [
          _c("div", { staticClass: "control" }, [
            _c(
              "button",
              {
                staticClass: "button is-primary",
                on: { click: _vm.onFilterClick },
              },
              [
                _c("span", { staticClass: "icon" }, [
                  _c("i", { staticClass: "mdi mdi-magnify mdi-18px" }),
                ]),
                _c("span", [_vm._v("Filter")]),
              ]
            ),
          ]),
          _c("div", { staticClass: "control" }, [
            _c(
              "button",
              { staticClass: "button", on: { click: _vm.onResetClick } },
              [
                _c("span", { staticClass: "icon" }, [
                  _c("i", { staticClass: "mdi mdi-refresh mdi-18px" }),
                ]),
                _c("span", [_vm._v("Reset")]),
              ]
            ),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }